<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'AdminUsers'}">
              <h4 class="ms-2">
                {{label.pages.personnels}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
              <small class="fw1">
                ({{label.pages.blockAdminUser}})
              </small>
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
              :show-row-lines="true"
              :show-column-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :rtl-enabled="true"
              :data-source="items"
              :columns="fields"
              :remote-operations="true"
              :column-auto-width="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              column-resizing-mode="widget"
              :hover-state-enabled="true"
              :noDataText="checkData"
              @toolbar-preparing="onToolbarPreparing($event)"
              key-expr="id"
              class="ps_Table"
              :height="dataGridHeight"
          >
            <DxSearchPanel
                :visible="true"
                :width="240"
                :placeholder="label.pages.search"
            />
            <DxColumnChooser
                :enabled="true"
                mode="dragAndDrop"
            />
            <DxExport
                :enabled="true"
            />
            <template #btnRGroup>
              <div></div>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-0">
                    <b-button
                        variant="ps-secondary"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.buttons.reload"
                        @click="reloadData"
                    >
                      <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #radif="{data}">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #image="{data}">
              <div>
                <img :src="data.data.imageAddress" class="ps_table_inside_img"/>
              </div>
            </template>
            <template #actions="{data}">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-1">
                  <button
                      @click="unban(data)"
                      :id="'cancelBanBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="arrow-right-square-fill" scale="1.1" variant="ps-add-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'cancelBanBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.unblock }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxLoadPanel :enabled="true"/>
            <DxScrolling mode="virtual"/>
            <DxStateStoring
                :enabled="true"
                type="localStorage"
                storage-key="adminBannedUsersList"
            />
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!-- Unban User Modal -->
    <b-modal
        dir="rtl"
        v-model="unbanModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.unblockConfirm}}
            <br/>
            <strong>« {{ unbanTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="unbanModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1"
                @click="unbanUser"
            >
            {{label.buttons.unblock}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'BlockedAdminUsers',
  mixins: [dataGridMixin],
  data() {
    return {
      label,
      fields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          cssClass: 'text-center align-middle fs10'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'firstName',
          caption: 'نام',
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'lastName',
          caption: 'نام خانوادگی',
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'image',
          caption: 'تصویر',
          allowSorting: false,
          allowFiltering: false,
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'mobileNumber',
          caption: 'شماره همراه',
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'nationalCode',
          caption: 'کد ملی',
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
      ],
      unbanModal: false,
      unbanId: null,
      unbanTitle: null,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      items: 'baseX/personnels',
      loadingBtn: 'loadingBtn',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.reloadData();
      }
    },
  },
  methods: {
    unban(item) {
      this.unbanId = item.data.id;
      this.unbanTitle = item.data.firstName + ' ' + item.data.lastName;
      this.unbanModal = true;
    },
    unbanUser() {
      this.$store.dispatch('baseX/banPersonnel', this.unbanId);
      this.unbanModal = false;
    },
    reloadData() {
      this.$store.dispatch('baseX/getBannedPersonnels');
    },
  },
  beforeCreate() {
    this.$store.dispatch('baseX/getBannedPersonnels');
  },
}
</script>
